export default __webpack_public_path__ + "static/media/tv-screen.391b2738.svg";